class ReloadForm {
	constructor(form) {
		var elements = form.elements,
			submitBtn = form.querySelector('[data-ReloadForm-submit]');

		//
		Array.prototype.forEach.call(elements, function(el){
			el.onchange = function(){
				var selected = this.nodeName === 'SELECT' ? this.options[this.selectedIndex] : this,
					url = selected.getAttribute('data-reloadform-field');

				//
				if(url) window.location = url;
			}
		});

		if(submitBtn) form.classList.add('js-active');
	}
}

export {ReloadForm};



































